// extracted by mini-css-extract-plugin
module.exports = {"Static_top":"Static_Static_top__2-FNn","Static_top_btn":"Static_Static_top_btn__3okHu","Static__gray":"Static_Static__gray__2l08h"};